/* Same-origin document prefetch. Native navigation, forms and Shopify app lifecycle stay intact. */
(() => {
  'use strict';
  if (window.Shopify?.designMode || !HTMLScriptElement.supports?.('speculationrules')) return;
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const paths = new Set([
    '/collections/見た目で選ぶ', '/collections/性能で選ぶ', '/collections/価格で選ぶ',
    '/pages/game-picker', '/pages/ゲームから選ぶ', '/pages/customize', '/pages/reviews', '/pages/business'
  ]);
  document.querySelectorAll('header a[href], header-drawer a[href]').forEach(link => {
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && !url.search && !url.hash && paths.has(decodeURIComponent(url.pathname)) && !link.hasAttribute('download') && (!link.target || link.target === '_self')) {
      link.dataset.tgPrefetch = '';
    }
  });
  if (!document.querySelector('a[data-tg-prefetch]')) return;
  const rules = document.createElement('script');
  rules.type = 'speculationrules';
  rules.textContent = JSON.stringify({prefetch: [{source: 'document', where: {selector_matches: 'a[data-tg-prefetch]'}, eagerness: 'moderate'}]});
  document.head.append(rules);
  // Keyboard users get the same preparation when they focus a header link.
  let focusRule;
  document.addEventListener('focusin', event => {
    const link = event.target.closest?.('a[data-tg-prefetch]');
    if (!link || link.href === location.href) return;
    focusRule?.remove();
    focusRule = document.createElement('script');
    focusRule.type = 'speculationrules';
    focusRule.textContent = JSON.stringify({prefetch: [{source: 'list', urls: [link.href]}]});
    document.head.append(focusRule);
  });
})();
